import React from 'react';

import { CumulativeReportPeriodDateField } from 'pages/Finance/CumulativeReport/components/CumulativeReportDatagrid/components/CumulativeReportPeriodDateField';
import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';
import { useListContext } from 'react-admin';
import { ContextMenu } from 'shared/mui/ContextMenu';
import { CurrencyField, FunctionField } from 'shared/react-admin/Fields';
import { CumulativeReport } from 'types/embedded/cumulativeReport';

import { CumulativeReportDatagridSummaryField } from './components/CumulativeReportDatagridSummaryField';
import { CumulativeReportDatagridTotalField } from './components/CumulativeReportDatagridTotalField';
import { CumulativeReportDatagridTransactionsButton } from './components/CumulativeReportDatagridTransactionsButton';
import { DatagridStyled } from './CumulativeReportDatagrid.styled';

type CumulativeReportDatagridProps = {
  filters: CumulativeReportFilterValues;
};

export const CumulativeReportDatagrid: React.FC<CumulativeReportDatagridProps> = ({ filters }) => {
  const { data: cumulativeReport = [], isLoading } = useListContext();

  return (
    <>
      <DatagridStyled bulkActionButtons={false} data={cumulativeReport} isLoading={isLoading}>
        <FunctionField
          cellClassName="column-index"
          render={(record: CumulativeReport) => {
            const index = cumulativeReport.indexOf(record) + 1;

            return index < 10 ? `0${index}` : index;
          }}
        />
        <FunctionField
          label="Период"
          render={({ periodFrom }: CumulativeReport) => (
            <CumulativeReportPeriodDateField periodFrom={periodFrom} timezone={filters.timezone} />
          )}
          source="periodFrom"
        />
        <CurrencyField
          alphaCodeSource="currencyCode"
          label="Валюта отчёта"
          nameSource="currencyName"
          source="currencyCode"
        />
        <CumulativeReportDatagridSummaryField
          color="green"
          label="Пополнения"
          source="paymentAmount"
          valueKey="paymentAmount"
        />
        <CumulativeReportDatagridSummaryField
          color="red"
          label="Выводы"
          source="payoutAmount"
          valueKey="payoutAmount"
        />
        <CumulativeReportDatagridSummaryField
          label="Рефанды"
          source="refundAmount"
          valueKey="refundAmount"
        />
        <CumulativeReportDatagridSummaryField
          label="Чарджбеки"
          source="chargeback"
          valueKey="chargeback"
        />
        <CumulativeReportDatagridSummaryField
          label="Комиссия за пополнения"
          source="commissionPaymentValue"
          valueKey="commissionPaymentValue"
        />
        <CumulativeReportDatagridSummaryField
          label="Комиссия за выводы"
          source="commissionPayoutValue"
          valueKey="commissionPayoutValue"
        />
        <CumulativeReportDatagridSummaryField
          label="Комиссия за рефанды"
          source="commissionRefundValue"
          valueKey="commissionRefundValue"
        />
        <CumulativeReportDatagridSummaryField
          label="Комиссия за чарджбеки"
          source="commissionChargebackValue"
          valueKey="commissionChargebackValue"
        />
        <CumulativeReportDatagridTotalField
          label="Итого за период"
          source="totalAmount"
          valueKey="totalAmount"
        />
        <CumulativeReportDatagridSummaryField
          label="Нарастающий итог"
          source="cumulativeTotalAmount"
          valueKey="cumulativeTotalAmount"
        />
        <ContextMenu
          render={(record: CumulativeReport) => (
            <CumulativeReportDatagridTransactionsButton filters={filters} record={record} />
          )}
        />
      </DatagridStyled>
    </>
  );
};
